import { Timezone, UserRole } from '@uplift/types';
import { restClient } from '../client';
import { State, County, StateAdmin } from '../resources';
import snakecaseKeys from 'snakecase-keys';


export const getAllStates = async () => restClient.request<{ data: State[] }>('/api/v1/geo/states');
export const getStateById = async (stateId: string) => restClient.request<{ data: State }>(`/api/v1/geo/states/${stateId}`);
export const getCountyByZip = async (zipCode: string) => restClient.request<{ data: County[] }>(`/api/v1/geo/county/${zipCode}`);

export type AllTimezonesResponse = {
  data: Timezone[];
};

export const getAllTimezones = async (role?: UserRole) => restClient.request<AllTimezonesResponse>('/api/v1/geo/timezones', {
  params: {
    user_role: role,
  }
});

export const getAllStatesAdmin = async () => restClient.request<{ data: StateAdmin[] }>('/api/v1/admin/geo/states');
export const getStateByIdAdmin = async (stateId: string) => restClient.request<{ data: StateAdmin }>(`/api/v1/admin/geo/states/${stateId}`);

export const manageState = async (data: StateAdmin) => restClient.request<StateAdmin>('/api/v1/admin/geo/states', {
  method: 'PATCH',
  data: snakecaseKeys(data)
});
